export default __webpack_public_path__ + "static/media/prev.456db707.webp";